    <div class="twk-sect">{{ label() }}</div>
    <ng-content></ng-content>
